/* eslint-disable-next-line no-restricted-imports */
import { t, tErrorLoading } from "utilities/localization-utils";

export const useLocalization = () => {
    return { t, tErrorLoading };
};
